import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'iq-central-front-end-upload-certificate',
  templateUrl: './upload-certificate.component.html',
  styleUrls: ['./upload-certificate.component.scss']
})
export class UploadCertificateComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

}
